import styled from 'styled-components';

export const PositionBarWrapper = styled.div`
  border-radius: 60px;
  display: flex;
  font-size: 15px;
  font-weight: 700;
  line-height: 21px;
  background-color: #f5f5f5;
`;
